"use strict";

/**
 * Provides some utility functions for somewhat efficiently modifying a
 * collection of headers.
 *
 * Note that this class only operates on ByteStrings (which is also why we use
 * toLowerCase internally).
 */
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HeaderList = /*#__PURE__*/function () {
  function HeaderList() {
    _classCallCheck(this, HeaderList);
    this.headers = new Map();
  }
  _createClass(HeaderList, [{
    key: "append",
    value: function append(name, value) {
      var existing = this.headers.get(name.toLowerCase());
      if (existing) {
        name = existing[0].name;
        existing.push({
          name: name,
          value: value
        });
      } else {
        this.headers.set(name.toLowerCase(), [{
          name: name,
          value: value
        }]);
      }
    }
  }, {
    key: "contains",
    value: function contains(name) {
      return this.headers.has(name.toLowerCase());
    }
  }, {
    key: "get",
    value: function get(name) {
      name = name.toLowerCase();
      var values = this.headers.get(name);
      if (!values) {
        return null;
      }
      return values.map(function (h) {
        return h.value;
      }).join(", ");
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      this.headers["delete"](name.toLowerCase());
    }
  }, {
    key: "set",
    value: function set(name, value) {
      var lowerName = name.toLowerCase();
      this.headers["delete"](lowerName);
      this.headers.set(lowerName, [{
        name: name,
        value: value
      }]);
    }
  }, {
    key: "sortAndCombine",
    value: function sortAndCombine() {
      var _this = this;
      var names = _toConsumableArray(this.headers.keys()).sort();
      return names.map(function (n) {
        return [n, _this.get(n)];
      });
    }
  }]);
  return HeaderList;
}();
module.exports = HeaderList;